import type { Immutable } from "immer";
import React from "react";

import type { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock/index";

export const Template = (
    props: Immutable<templates.CustomerServiceInfoBlockTemplate>,
): React.JSX.Element => {
    return <CustomerServiceInfoBlock {...props} />;
};
